import { useInfiniteQuery } from '@tanstack/react-query';

import {
  formatInfiniteData,
  getNextPageParam,
} from 'components/helpers/reactQuery';

export function useInfiniteCompanyRolesPersonnelQuery({
  companyRoleId,
  queryOptions,
}) {
  return useInfiniteQuery({
    queryKey: ['companyRoles', companyRoleId, 'personnel'],
    queryFn: async ({ pageParam = 1 }) => {
      const response = await axios.get(
        `/company_roles/${companyRoleId}/personnel`,
        { params: { page: pageParam } },
      );

      return response.data;
    },
    getNextPageParam,
    select: (data) =>
      formatInfiniteData({
        data,
        resourceTypes: ['profilePhoto', 'subcontractor'],
      }),
    ...queryOptions,
  });
}
